//========== NavBar Component ==========

import { useState, useEffect } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import logo from "../../assets/img/Logo-img/Logo.webp";
import { HashLink } from "react-router-hash-link";
import "./navbar.scss";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const NavBar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("");
  useEffect(() => {
    const handleScroll = () => {
      var _document$getElementB, _document$getElementB2, _document$getElementB3, _document$getElementB4, _document$getElementB5, _document$getElementB6;
      const currentScrollPos = window.pageYOffset;
      setScrolled(currentScrollPos > 50);
      const sectionOffsets = {
        home: (_document$getElementB = document.getElementById("home")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.offsetTop,
        about: (_document$getElementB2 = document.getElementById("about")) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.offsetTop,
        services: (_document$getElementB3 = document.getElementById("services")) === null || _document$getElementB3 === void 0 ? void 0 : _document$getElementB3.offsetTop,
        skills: (_document$getElementB4 = document.getElementById("skills")) === null || _document$getElementB4 === void 0 ? void 0 : _document$getElementB4.offsetTop,
        experience: (_document$getElementB5 = document.getElementById("experience")) === null || _document$getElementB5 === void 0 ? void 0 : _document$getElementB5.offsetTop,
        projects: (_document$getElementB6 = document.getElementById("projects")) === null || _document$getElementB6 === void 0 ? void 0 : _document$getElementB6.offsetTop
      };
      const scrollPosition = window.pageYOffset + 300;
      let foundSection = "";
      for (const section in sectionOffsets) {
        if (sectionOffsets[section] <= scrollPosition) {
          foundSection = section;
        }
      }
      setActiveSection(foundSection);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  const linkClassName = sectionName => activeSection === sectionName ? "navbar-link underline" : "navbar-link";
  return /*#__PURE__*/_jsx(Navbar, {
    expand: "lg",
    className: scrolled ? "scrolled" : "",
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx(Navbar.Brand, {
        href: "#home",
        children: /*#__PURE__*/_jsx("img", {
          src: logo,
          alt: "Logo"
        })
      }), /*#__PURE__*/_jsx(Navbar.Toggle, {
        "aria-controls": "basic-navbar-nav"
      }), /*#__PURE__*/_jsxs(Navbar.Collapse, {
        id: "basic-navbar-nav",
        children: [/*#__PURE__*/_jsxs(Nav, {
          className: "ms-auto",
          children: [/*#__PURE__*/_jsx(Nav.Link, {
            href: "#home",
            className: linkClassName("home"),
            children: "Home"
          }), /*#__PURE__*/_jsx(Nav.Link, {
            href: "#about",
            className: linkClassName("about"),
            children: "About"
          }), /*#__PURE__*/_jsx(Nav.Link, {
            href: "#services",
            className: linkClassName("services"),
            children: "Services"
          }), /*#__PURE__*/_jsx(Nav.Link, {
            href: "#skills",
            className: linkClassName("skills"),
            children: "Skills"
          }), /*#__PURE__*/_jsx(Nav.Link, {
            href: "#experience",
            className: linkClassName("experience"),
            children: "Experience"
          }), /*#__PURE__*/_jsx(Nav.Link, {
            href: "#projects",
            className: linkClassName("projects"),
            children: "Projects"
          })]
        }), /*#__PURE__*/_jsx("span", {
          className: "navbar-text",
          children: /*#__PURE__*/_jsx(HashLink, {
            to: "#connect",
            children: /*#__PURE__*/_jsx("button", {
              className: "vvd",
              children: /*#__PURE__*/_jsx("span", {
                children: "Let\u2019s Connect"
              })
            })
          })
        })]
      })]
    })
  });
};
export default NavBar;